import { CircularProgress, Box, Paper, Dialog, DialogTitle, IconButton, DialogContent } from "@mui/material";
import React, { useState, useEffect } from "react";
import Draggable from "react-draggable";
import CloseIcon from '@mui/icons-material/Close';
import { MAP_API_URL, MAP_CONFIG_ID, MAP_CONSUMER_KEY } from "../../../constants";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const VenueMapDialog = ({ open, handleClose, data }) => {
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [eventData, setEventData] = useState(null);
  const [mapData, setMapData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadScriptsForMaps();

    window.mapCallback = (data) => {
      setEventData(data[0])
      setMapData(data[1])
    }

    return () => {
      window.mapCallback = undefined
    }
  }, [])

  useEffect(() => {
    if (!eventData || !mapData) {
      setError("Map is not available for this event")
      return;
    }

    if (!window.Seatics || !window.$) {
      setError("Script loading error")
      return;
    }

    setError(null)

    const container = window.$('#tn-maps div');

    container.width(550);
    container.height(450);

    window.Seatics.MapComponent.create({
      imgSrc: eventData.mapImage,
      tickets: data.seatsData,
      mapData: mapData,
      vfsUrl: 'https://vfs.seatics.com/',
      container: container,
      mapWidth: 550,
      mapHeight: 450,
      mapName: eventData.mapName,
      presentationInterface: {},
      centerInContainer: false,
      disableResize: false,
      addLegendHtml: true,
      enableLegend: true,
      enableSectionInfoPopups: true
    });

    return () => {
      container.empty()
    }
  }, [eventData, mapData])

  useEffect(() => {
    if (!data)
      return;

    const mapApiEndpoint = constructMapApiEndPoint(data.eventId);

    if (!mapApiEndpoint) {
      setError("Error in constructMapApiEndPoint")
      return;
    }

    createScript(mapApiEndpoint);

    return () => {
      removeScriptByUrl(mapApiEndpoint)
    }
  }, [data])

  const constructMapApiEndPoint = (eventId) => {
    if (!MAP_CONFIG_ID || !MAP_CONSUMER_KEY || !MAP_API_URL) {
      console.log("[constructMapApiEndPoint] MAP_CONFIG_ID", MAP_CONFIG_ID)
      console.log("[constructMapApiEndPoint] MAP_CONSUMER_KEY", MAP_CONSUMER_KEY)
      console.log("[constructMapApiEndPoint] MAP_API_URL", MAP_API_URL)
      return null
    }

    const configId = MAP_CONFIG_ID;
    const consumerKey = MAP_CONSUMER_KEY;
    const endpoint = MAP_API_URL;

    return `${endpoint}?websiteConfigId=${configId}&eventId=${eventId}&consumerKey=${consumerKey}&callback=mapCallback`;
  }

  const createScript = (url) => {
    if (document.querySelector(`script[src="${url}"]`)) {
      return false;
    }
    setIsDataLoading(true);

    const script = document.createElement('script');
    script.onload = () => {
      setIsDataLoading(false);
    };
    script.src = url;
    script.type = 'text/javascript';
    script.async = false;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  const removeScriptByUrl = (url) => {
    const scripts = document.querySelectorAll(`script[src="${url}"]`);
    const head = document.getElementsByTagName('head')[0];

    scripts.forEach((script) => {
      head.removeChild(script);
    });
  }

  const loadScriptsForMaps = () => {
    loadScript(('https:' === document.location.protocol ? 'https:' : 'http:') + '//ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js')
    loadScript('https://mapwidget3.seatics.com/Api/framework')
  }

  const loadScript = (url) => {
    if (document.querySelector(`script[src="${url}"]`)) {
      return true;
    }
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      
      sx={{"& .MuiDialog-paper": {minWidth: 200}}}
    >
      <DialogTitle sx={{ m: 0, p: 2, cursor: 'move' }} id="draggable-dialog-title">
        Venue Map
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Box sx={{display: 'flex', justifyContent: 'center'}}>
          {
            isDataLoading ? <CircularProgress /> :
              error
          }
          <div id="tn-maps">
            <div className="placeholder">
            </div>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default VenueMapDialog